/**
 * Проверка ответов шлюза для окна «Диагностика» на границе (D-056): версия шлюза (строка реестра «О приложении»)
 * и его готовность. Неожиданная форма — ошибка разбора, а не пустой экран.
 */
import { fail, isRecord, list, record } from '../../../shared/decode'
import type { ServiceReadiness, ServiceVersion } from '../model/types'

/** `{ service, version }` — `MapResourceDiagnostics` и строка шлюза в «О приложении». */
export function decodeServiceVersion(raw: unknown): ServiceVersion {
  const body = record(raw, 'версия')
  if (typeof body.service !== 'string' || body.service === '') fail('поле service — не строка')
  if (typeof body.version !== 'string' || body.version === '') fail('поле version — не строка')
  return { service: body.service, version: body.version }
}

/** Строка шлюза в ответе «О приложении» (`id: gateway`); без неё ответ не по договору. */
function gatewayEntry(raw: unknown): Record<string, unknown> {
  const body = record(raw, 'о приложении')
  const entry: unknown = list(body.services, 'services', (item) => item).find((item) => isRecord(item) && item.id === 'gateway')
  return record(entry, 'строка шлюза')
}

/** Версия шлюза из `GET /api/gateway/v1/about`: название строки реестра — «служба», номер — версия. */
export function decodeGatewayVersion(raw: unknown): ServiceVersion {
  const entry = gatewayEntry(raw)
  return decodeServiceVersion({ service: entry.name, version: entry.version })
}

/**
 * Готовность шлюза — `GET /api/gateway/v1/ready` (FIX-A2): `status: ready` — шлюз
 * настроен. «Не готов» приходит 503 и становится ошибкой transport `unavailable`
 * со словами шлюза; иной статус в ответе 200 — не по договору.
 */
export function decodeGatewayReadiness(raw: unknown): ServiceReadiness {
  const body = record(raw, 'готовность шлюза')
  if (body.status !== 'ready') fail(typeof body.message === 'string' && body.message !== '' ? body.message : 'шлюз не готов')
  return { status: 'готов к работе' }
}
